<template>
  <div class="header-page">
    <div class="Title">
      <h3>{{ pageTitle }}</h3>
    </div>
    <p>{{ pageSubTitle }}</p>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    pageSubTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.header-page {
  display: flex;
  margin: 1em 0;
  align-items: baseline;
}
.Title {
  padding-right: 1em;
  margin-right: 1em;
  border-right: 1px solid gainsboro;
}

h3 {
  color: #2f5293;
}

p {
  color: gray;
}
</style>
